import ZoeRoute from './routes';

export default function getUserGuidePath(section?: string) {
  return `${ZoeRoute.Documentation}/${window.CONFIG.isMidasPeer ? 'midas-landing-page' : 'thw-user-guide'}/${section ? section : ''}`;
}
